import { useQuery } from "@tanstack/react-query";
import { customFetcher } from "../useFetch";
import { ITemplate } from "../../interfaces/ITemplate";

export const useGetTemplates = () => {
    const {
        data: templates,
        isLoading: isLoadingTemplates,
        refetch: refetchTemplates,
    } = useQuery<ITemplate[]>({
        queryKey: ["template/"],
        queryFn: () => customFetcher({ endpoint: "/template/" }),
    });
    return { templates, isLoadingTemplates, refetchTemplates };
};

export const useGetTemplateById = (id: number) => {
    const {
        data: template,
        isLoading: isLoadingTemplate,
        refetch: refetchTemplate,
    } = useQuery<ITemplate>({
        queryKey: ["template/", id],
        queryFn: () => customFetcher({ endpoint: `/template/${id}` }),
        enabled: !!id,
    });
    return { template, isLoadingTemplate, refetchTemplate };
};
